import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../elements/button'
import Icon from '../../../../../components/icons'
import SaveFeaturesModal from '../modals/saveFeatures.modal'
import ZoneDesignTablesAccordians from '../zoneDesignTablesAccordians'
import { ChatQuerySave } from './useChatQuerySave'

interface Props {
    save: ChatQuerySave
    // The SQL the chat applied, offered to the Save Features modal.
    query?: string | null
    children: React.ReactNode
}

// The chat with the same "existing tables" list and Save Features button the SQL tab has.
const Nl2sqlTabLayout: React.FC<Props> = ({ save, query, children }) => {
    const { t } = useTranslation()
    return (
        <div data-testid="nl2sql-tab-layout">
            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2">{children}</div>
                <div data-testid="accordion-container">
                    <ZoneDesignTablesAccordians />
                </div>
            </div>
            <div className="my-4">
                <Button theme="secondary" styleType="outline" size="xs" onClick={save.open} disabled={!save.unsaved} data-testid="nl2sql-save-features-button">
                    <Icon name="save" />
                    {t('Save Features')}
                </Button>
            </div>
            <SaveFeaturesModal _ref={save.modalRef} query={query} onSaved={save.markSaved} />
        </div>
    )
}

export default Nl2sqlTabLayout
